module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAhCAYAAAC4JqlRAAAAAXNSR0IArs4c6QAAAVdJREFUWEftlt1NwzAURj+HDMAzEmnZoCPcjsAEwASICdoRukHFBkzQmAnaDdpQBsg7KK4sxZLl+l9ILZLzGtvf8bnXThgu/LAL5+N/AxyJSAC3DecfuSazDXwRPQNYj8G84XyeA5ENcCRqBUAqtK6q6d1m06VCFIBioBgoBoqB6zTQES0ZsGDA7hd4fOD8YN7xsd+Cca1XAfQDMDfXOjPwTTQbgK0KFMDBNjEGQG1Eg181nL/pmzkD2BNNb4C9PsgGEQKwhMslwwByVEck9S99ED4AW7gAdqPJ3mtAvQxBuABSwmWW9xT4IGpgbf6Q/AzDi2xew5x152pM8Bi6ICqgF8BMa9Z3BjylhAcN+MoR+vVy1dycFzSQAxEbHm0gBSIlPBnAdUS1PvA2nK1s0SXQJzsaMzk8y4CtHKnaoy6iUJfL9/Larhmb3LftZ8z4PytBbthVApwAM5kNMfsyYU0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_down.png
// module id = U6zf
// module chunks = 1